import { Component, OnInit } from '@angular/core';
import { ConnectionService } from '../../connection.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { WalletserviceService } from 'src/app/services/walletservice.service';
import { nft_abi } from '../../contracts/nft_abi'
import { nft_bytecode } from '../../contracts/nft_bytecode'
import { trc20_bytecode } from '../../contracts/trc20_bytecode'
import { trc20_abi } from '../../../app/contracts/trc20_abi'
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-contracts-triggers',
  templateUrl: './contracts-triggers.component.html',
  styleUrls: ['./contracts-triggers.component.css']
})
export class ContractsTriggersComponent implements OnInit {
  transactions = []; token = localStorage.getItem('Sastana_Token'); trans: number = 1;
  tokenAddress: any;
  transactionList: any = {};
  marketCap: any;
  tabName: any;
  contractAddress: any;

  burn: any = {
    amount: ''
  }
  allowance: any = {};
  decreaseallowance: any = {};
  increaseallowance: any = {};
  transfer: any = {};
  transferFrom: any = {};
  approve: any = {}
  ownership: any = {
    address: ''
  }
  nftapproval: any = {}
  nftTokenid: any = {
    tokenId: ''
  }
  nftowner: any = {
    tokenId: ''
  }
  nftSupport: any = {
    interfaceId: ''
  }
  nfttokenuri: any = {
    tokenId: ''
  }
  nftapprove: any = {};
  nftmint: any = {
    to: ''
  }
  nfttransferFrom: any = {}
  transferOwnership: any = {
    owner: ''
  }
  nftsetapprove: any = {}
  nftsafeFrom: any = {}
  nftsafeTransfer: any = {}
  mint: any = {}
  balance: any = {
    address: ''
  };
  nftBalance: any = {
    ownerAddress: ''
  }
  matchType: any;
  result: any;
  conBalance: any;
  contractValue: any;
  writeMethods: any;
  dashboardDetails: any;
  Latestblock: any;
  totalTxns: any;
  totalAccounts: any;
  currentTPS: any;
  totalNodes: any;
  totalFrozen: any;
  allowanceResult: any;
  approveResult: any;
  burnResult: any;
  transferResult: any;
  decreaseallowanceResult: any;
  increaseallowanceResult: any;
  transferFromResult: any;
  userAddress = localStorage.getItem('Address')
  abi: number;
  abiArray: any;
  byteCode: any;
  nftRead: any;
  nftWrite: any;
  trc721: any;
  trc721byte: any;
  trc20byte: any;
  trc20: any;
  nftcontract: any;
  jsonarray: string;
  jsonabi: string;
  nftBal: any;
  nftgetapprove: any;
  nftisapprove: any;
  nftisowner: any;
  nftsupportsInterface: any;
  nfttokenURI: any;
  nftApproveResult: any;
  nftsafeMintResult: any;
  nftsafeTransferFromResult: any;
  nftsetApprovalResult: any;
  nfttransferFromResult: any;
  expandView: any = false
  expandView1: any = false
  signLoader = false;
  tokenname: string;
  searchobj: any = {
    searchAddress: ''
  }
  searchListDetails: any;
  conData: any = {};
  assetID: any;
  tokenName: any;
  abc10Info: any;

  timeStamp = '15819284890000'
  abc10Data: any;
  tokenTransfers: any;
  tokenTransfers24h: any;
  abc10Transfers: any;
  abc20tokenHolders: any;
  loadingItem: any;
  totalSupply: any;
  readItem: any;

  constructor(private walletservice: WalletserviceService, private conn: ConnectionService, private alert: ToastrService, private activatedRoute: ActivatedRoute, private router: Router, private spinner: NgxSpinnerService
  ) {
    this.getReadAbi();
    this.getWriteAbi();
    this.getnftReadAbi();
    this.getnftWriteAbi()
    this.latestBlockDetails();
    this.getABC10Info()
    this.trc20 = trc20_abi;
    this.trc20byte = trc20_bytecode
    this.trc721 = nft_abi;
    this.trc721byte = nft_bytecode
  }

  ngOnInit() {
    this.getPriceDetails();
    // this.gettokenHolders();
    this.contractAddress = this.activatedRoute.snapshot.params['address']
    this.tokenName = this.activatedRoute.snapshot.params['name']

    if (this.contractAddress.length == 34) {
      this.tokenAddress = this.contractAddress
      this.gettrcTotalSupply();
      this.getnftreadDetails();
      this.getTrcDetails();
      this.getTokentransfer();
      this.get24hrTransferCount();
    }
    else if (this.contractAddress == 1000001) {
      this.assetID = this.contractAddress
      this.tokenname = this.tokenName
      this.getabc10Info();
      this.getABC10Transfers()
    }
    else {
      this.tokenname = this.tokenName
    }
    this.conn.setRoute.subscribe((res: any) => {
      this.spinner.show()
      if (res) {
        this.contractAddress = this.activatedRoute.snapshot.params['address']
        if (this.contractAddress.length == 34) {
          this.spinner.hide()
          this.tokenAddress = this.contractAddress

        }
        else {
          this.spinner.hide()
          this.tokenname = this.contractAddress
        }
      }
    })
    setTimeout(() => {
      this.getContractDetails();
    }, 1000)
  }

  getABC10Info() {
    this.conn.postUrl('user_contract/ABC10_token_info', {}).subscribe((res: any) => {
      if (res.status == true) {
        this.abc10Info = res.data
      }
    })
  }

  gettokenHolders() {
    this.conn.postUrl('contract/gettokenBalanceofUsers', {}).subscribe((res: any) => {
      if (res.status == true) {
        this.abc20tokenHolders = res.data
      }
    })
  }


  getTokenName() {
    this.conn.postUrl('wallet/getTokenName', { contract_address: this.tokenAddress }).subscribe((res: any) => {
      if (res.status == true) {
        this.tokenname = 'TRC20'
      }
      else {
        this.tokenname = 'TRC721'
      }
    })
  }

  getabc10Info() {
    this.conn.postUrl('token/recordToken', { tokenType: 'ABC10' }).subscribe((res: any) => {
      if (res.success == true) {
        this.abc10Data = res.data[0]
      }
    })
  }

  getContractDetails() {
    this.spinner.show()
    this.conn.postUrl('token/getTokenInfo', { contract: this.tokenAddress, tokenType: this.tokenname }).subscribe((res: any) => {
      this.spinner.hide()
      if (res.success == true) {
        this.conData = res.data[0] ? res.data[0] : res.data
      }
    })
  }

  latestBlockDetails() {
    this.conn.postUrl('users/dashboard-data', {}).subscribe((res: any) => {
      this.dashboardDetails = res.data
      this.Latestblock = this.dashboardDetails.latestBlocks
      this.totalTxns = this.dashboardDetails.totalTxns
      this.totalAccounts = this.dashboardDetails.totalAccounts
      this.currentTPS = this.dashboardDetails.currentTPS
      this.totalNodes = this.dashboardDetails.totalNodes
      this.totalFrozen = this.dashboardDetails.totalFrozen
    })
  }

  async getReadAbi() {
    this.result = await trc20_abi.filter(item =>
      (item.type == 'Function' && item.stateMutability == 'View'))
  }

  async getWriteAbi() {
    this.writeMethods = await trc20_abi.filter(item =>
      (item.type == 'Function' && item.stateMutability == "Nonpayable"))
  }

  async getnftReadAbi() {
    this.nftRead = await nft_abi.filter(item =>
      (item.type == 'Function' && item.stateMutability == 'View'))
  }

  async getnftWriteAbi() {
    this.nftWrite = await nft_abi.filter(item =>
      (item.type == 'Function' && item.stateMutability == "Nonpayable"))

  }

  getSearch(type: any, search: any) {
    if (type == 'address' || type == 'transHash' || type == 'blockNumber') {
      this.router.navigate(['/tag/', type, search])
    }
    else {
      this.router.navigate(['/contract-read/', search])
    }
  }

  getPriceDetails() {
    this.conn.postUrl('adminNew/getSastanaVolume', {}).subscribe((res: any) => {
      this.marketCap = res.data[2].value
    })
  }

  getTokentransfer() {
    this.conn.postUrl('contract/getContracttransByaddress', { contract: this.contractAddress }).subscribe((res: any) => {
      this.tokenTransfers = res.data
    })
  }

  get24hrTransferCount() {
    this.conn.postUrl('contract/24hrtokenTransfer', { contract: this.contractAddress }).subscribe((res: any) => {
      this.tokenTransfers24h = res.data
    })
  }

  getABC10Transfers() {
    this.conn.postUrl('contract/getABC10Transfers', {}).subscribe((res: any) => {
      this.tokenTransfers = res.data
    })

  }
  // trc20

  getBalance() {
    if (this.balance.address) {
      this.signLoader = true
      this.conn.postUrl('contract/getBalance', { address: this.balance.address }).
        subscribe((result: any) => {
          this.signLoader = false
          this.conBalance = result.data.Balance
        })
    }
    else {
      this.signLoader = false
    }

  }

  getTrcDetails() {
    this.readItem = name
    this.conn.postUrl('contract/gettrcDetails', { address: this.userAddress, method : name}).
      subscribe((result: any) => {
        this.contractValue = result.data
      })
  }

  gettrcTotalSupply() {
    if (this.contractAddress != 'SbZgDdiSKabXhJbDV7VNere98s1basgN3A')
      this.conn.postUrl('contract/getTotalSupply', { address: this.userAddress, contract: this.contractAddress }).
        subscribe((result: any) => {
          this.totalSupply = result.data.totalSupply
        })
  }

  getAllowance() {
    if (this.allowance.ownerAddress && this.allowance.spenderAddress) {
      this.signLoader = true
      this.conn.postUrl('contract/allowance', {
        ownerAddress: this.allowance.ownerAddress,
        spenderAddress: this.allowance.spenderAddress,
      }).
        subscribe((result: any) => {
          if (result.status == true) {
            this.signLoader = false
            this.allowanceResult = result.data.Allowance
          }
          else {
            this.alert.error(result.msg);
          }
        })
    }
    else {
      this.signLoader = false
    }

  }

  writeApprove() {
    if (this.approve.amount && this.approve.spenderAddress) {
      this.signLoader = true
      this.conn.postUrl('contract/approve', {
        spenderAddress: this.approve.spenderAddress,
        amount: this.approve.amount,
        address: this.userAddress
      }).
        subscribe((result: any) => {
          if (result.status == true) {
            this.signLoader = false
            this.approveResult = result.data
          }
          else {
            this.alert.error(result.msg);
          }

        })
    }
    else {
      this.signLoader = false
    }

  }

  writeBurn() {
    if (this.burn.amount) {
      this.signLoader = true
      this.conn.postUrl('contract/burn', {
        amount: this.burn.amount,
        address: this.userAddress
      }).
        subscribe((result: any) => {
          if (result.status == true) {
            this.signLoader = false
            this.burnResult = result.data
          }
          else {
            this.alert.error(result.msg);
          }
        })
    }
    else {
      this.signLoader = false
    }

  }

  writedecreaseAllowance() {
    if (this.decreaseallowance.spenderAddress && this.decreaseallowance.amount) {
      this.signLoader = true
      this.conn.postUrl('contract/decreaseAllowance', {
        spenderAddress: this.decreaseallowance.spenderAddress,
        amount: this.decreaseallowance.amount,
        address: this.userAddress
      }).
        subscribe((result: any) => {
          if (result.status == true) {
            this.signLoader = false
            this.decreaseallowanceResult = result.data
          }
          else {
            this.alert.error(result.msg);
          }
        })
    }
    else {
      this.signLoader = false
    }
  }

  writeincreaseAllowance(name : any) {
    if(this.increaseallowance.spenderAddress && this.increaseallowance.amount) {
      this.signLoader = true;
      this.loadingItem = name
      this.conn.postUrl('contract/increaseAllowance', {
        spenderAddress: this.increaseallowance.spenderAddress,
        amount: this.increaseallowance.amount,
        address: this.userAddress
      }).
        subscribe((result: any) => {
          if (result.status == true) {
            this.signLoader = false
            this.increaseallowanceResult = result.data
          }
          else {
            this.alert.error(result.msg);
          }
        })
    }
    else {
      this.signLoader = false
    }
    
  }

  writeTransfer() {
    this.signLoader = true
    this.conn.postUrl('contract/transfer', {
      toAddress: this.transfer.toaddress,
      amount: this.transfer.amount,
      address: this.userAddress
    }).
      subscribe((result: any) => {
        if (result.status == true) {
          this.signLoader = false
          this.transferResult = result.data
        }
        else {
          this.alert.error(result.msg);
        }
      })
  }

  writeTransferfrom() {
    this.conn.postUrl('contract/transferFrom', {
      fromAddress: this.transferFrom.fromaddress,
      toAddress: this.transferFrom.toaddress,
      amount: this.transferFrom.amount,
      address: this.userAddress
    }).
      subscribe((result: any) => {
        if (result.status == true) {
          this.transferFromResult = result.data
        }
        else {
          this.alert.error(result.msg);
        }
      })
  }


  //trc721 read

  getnftreadDetails() {
    this.conn.postUrl('contract/getnftDetails', { address: this.userAddress }).
      subscribe((result: any) => {
        this.nftcontract = result.data
      })
  }

  getnftBalance() {
    this.conn.postUrl('wallet/nftgetBalance', { address: this.nftBalance.ownerAddress }).
      subscribe((result: any) => {
        this.nftBal = result.data.Balance
      })
  }

  getApproved() {
    this.conn.postUrl('wallet/getApproved',
      {
        address: this.userAddress,
        tokenId: this.nftTokenid.tokenId
      }).
      subscribe((result: any) => {
        this.nftgetapprove = result.data.result
      })
  }

  isApproved() {
    this.conn.postUrl('wallet/isApproved',
      {
        address: this.userAddress,
        owner: this.nftapproval.ownerAddress,
        operator: this.nftapproval.operator
      }).
      subscribe((result: any) => {
        this.nftisapprove = result.data.result
      })
  }

  isOwner() {
    this.conn.postUrl('wallet/ownerof',
      {
        address: this.userAddress,
        tokenId: this.nftowner.tokenId
      }).
      subscribe((result: any) => {
        this.nftisowner = result.data.result
      })
  }

  supportsInterface() {
    this.conn.postUrl('wallet/supportsInterface',
      {
        address: this.userAddress,
        interfaceId: this.nftSupport.interfaceId
      }).
      subscribe((result: any) => {
        this.nftsupportsInterface = result.data
      })
  }

  tokenuri() {
    this.conn.postUrl('wallet/tokenURI',
      {
        address: this.userAddress,
        tokenId: this.nfttokenuri.tokenId
      }).
      subscribe((result: any) => {
        this.nfttokenURI = result.data.result
      })
  }

  //trc721 write

  writenftapprove() {
    this.conn.postUrl('wallet/nftapprove',
      {
        address: this.userAddress,
        toAddress: this.nftapprove.to,
        tokenId: this.nftapprove.tokenId
      }).
      subscribe((result: any) => {
        if (result.status == true) {
          this.nftApproveResult = result.data
        }
        else {
          this.alert.error(result.msg);
        }
      })
  }


  writesafeMint() {
    this.conn.postUrl('contract/safeMint',
      {
        address: this.userAddress,
        toAddress: this.nftmint.to,
        mintId: this.nftmint.tokenId,
        uri: this.nftmint.uri
      }).
      subscribe((result: any) => {
        if (result.status == true) {
          this.nftsafeMintResult = result.data
        }
        else {
          this.alert.error(result.msg);
        }
      })
  }


  writesafeTransferFrom() {
    this.conn.postUrl('contract/safeTransferFrom',
      {
        address: this.userAddress,
        fromAddress: this.nftsafeTransfer.from,
        toAddress: this.nftsafeTransfer.to,
        tokenId: this.nftsafeTransfer.tokenId
      }).
      subscribe((result: any) => {
        if (result.status == true) {
          this.nftsafeTransferFromResult = result.data
        }
        else {
          this.alert.error(result.msg);
        }
      })
  }


  writesetApprovalForAll() {
    this.conn.postUrl('contract/setApprovalForAll',
      {
        address: this.userAddress,
        operator: this.nftsetapprove.operator,
        approved: this.nftsetapprove.approved
      }).
      subscribe((result: any) => {
        if (result.status == true) {
          this.nftsetApprovalResult = result.data
        }
        else {
          this.alert.error(result.msg);
        }
      })
  }

  writetransferFrom() {
    this.conn.postUrl('contract/nfttransferFrom',
      {
        address: this.userAddress,
        fromAddress: this.nfttransferFrom.from,
        toAddress: this.nfttransferFrom.to,
        tokenId: this.nfttransferFrom.tokenId

      }).
      subscribe((result: any) => {
        if (result.status == true) {
          this.nfttransferFromResult = result.data
        }
        else {
          this.alert.error(result.msg);
        }
      })
  }


  copyText(val: string) {
    let selBox = document.createElement('input');
    selBox.value = val;
    document.body.appendChild(selBox);
    selBox.focus();
    selBox.select();
    document.execCommand('copy');
    document.body.removeChild(selBox);
    this.alert.success('Copied to the clipboard');
  }


  copyArrayText(val: string) {
    let value = JSON.stringify(val)
    let selBox = document.createElement('input');
    selBox.value = value;
    document.body.appendChild(selBox);
    selBox.focus();
    selBox.select();
    document.execCommand('copy');
    document.body.removeChild(selBox);
    this.alert.success('Copied to the clipboard');
  }

  searchDetails(type: any, search: any) {

    if (type == 'address' || type == 'transHash' || type == 'blockNumber') {
      this.router.navigate(['/tag/', type, search])
    }
    else {
      this.router.navigate(['/contract-read/', search])
      window.location.reload()
    }
  }




}




